import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Introduction",
  layout: {
    type: "table",
    options: {
      cols: 3,
      rows: 2,
      rowSpan: {
        "0:0": 2,
        "0:2": 2,
      },
      gap: "20px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  formatter: "html",
                  scrollbars: false,
                  data: `The psychoacoustic parameters and binaural measurement methods introduced and described in this module can be used to design and improve the sounds of all kinds of machines and appliances, from airplane turbines to electric shavers. Through the process of sound quality analysis, desirable and undesirable sound components can be identified and the impact of eventual modifications and improvements on user experience can be quantified. This means that sound quality assessment is always user-centered and involves human sound perception during measurement, analysis and evaluation.<br /><br />
                  While quiet or noiseless products might be desirable and appropriate in certain applications, a well-designed product sound is one that meets the user’s expectations in the corresponding context and leads to a positive experience, this can include transmitting information about the operating state, condition, build quality or even the brand of a product to the user.<br /><br />
                  In this case study we will take you through the process of sound quality evaluation and metric generation using an electric coffee machine as an example. The process of binaural sound recording and processing, psychoacoustic analysis, perceptual evaluation, and metric generation will be introduced before showcasing different application examples in more depth.
                  `,
                },
              },
              styles: {
                fontSize: "12px",
                fontWeight: 600,
                alignItems: "flex-start",
                width: "95%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/case01/slide01-image01.svg`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/case01/slide01-image03.svg`,
                },
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/case01/slide01-image02.svg`,
                },
              },
            },
          },
        ],
      ],
    },
    styles: {
      width: "1024px",
      height: "562px",
      alignSelf: "center",
    },
  },
};

export default principle;
